import { useTranslation } from "react-i18next";
import AdminButton from "./AdminButton";
import confirmDelete from "./confirmDelete";

/**
 * Delete button with a mandatory confirmation dialog, so every SuperAdmin list
 * gets the same "are you sure?" guard for free.
 *
 * props:
 *   onConfirm  - called only when the user confirms
 *   message    - optional body text (defaults to a generic warning)
 *   label      - optional button text (defaults to t("delete"))
 *   children   - optional custom button content (overrides label; e.g. an icon)
 *
 * Icon-only usages still get an accessible name, since the fallback title/aria-label
 * is always the translated "delete".
 */
export default function ConfirmDeleteButton({ onConfirm, message, label, children, ...rest }) {
  const { t } = useTranslation();
  const accessibleName = label || t("delete");

  const handleClick = () => {
    confirmDelete({
      title: t("areYouSure"),
      message: message || t("deleteConfirmMessage"),
      confirmText: t("yes"),
      cancelText: t("giveUp"),
      onConfirm,
    });
  };

  return (
    <AdminButton
      variant="danger"
      onClick={handleClick}
      title={accessibleName}
      aria-label={accessibleName}
      {...rest}
    >
      {children || accessibleName}
    </AdminButton>
  );
}
